package org.chiangmeng.qfast.core.domain.usecases

import org.chiangmeng.qfast.core.domain.ports.QueueRepository

class NextQueueUseCase(private val repository: QueueRepository) {
    suspend operator fun invoke(shopId: String, category: String): Int? =
        repository.nextQueue(shopId, category)
}